import styled from 'styled-components';

const AssignmentInfoDiv = styled.div`
  padding: 0px 24px;
  margin-bottom: 20px;
`;

export default AssignmentInfoDiv;
